function chain(...callbacks) {
  return (...args) => {
    const fns = callbacks.filter(Boolean);
    fns.forEach((callback) => callback(...args));
  };
}
const clsx = (...args) => args.filter(Boolean).join(" ");
function mergePropsInner(a, b) {
  const res = {};
  Object.keys(a).forEach((key) => {
    var _a, _b;
    if (/^on[A-Z]/.test(key) && typeof a[key] === "function" && typeof b[key] === "function") {
      res[key] = chain(a[key], b[key]);
      return;
    }
    if (key === "className") {
      const left = (_a = a.className) == null ? void 0 : _a.toString();
      const right = (_b = b.className) == null ? void 0 : _b.toString();
      res[key] = clsx(left, right);
      return;
    }
    res[key] = b[key] ?? a[key];
  });
  Object.keys(b).filter((key) => !(key in a)).forEach((key) => {
    res[key] = b[key];
  });
  return res;
}
function mergeProps(...args) {
  return args.reduce((left, right) => mergePropsInner(left, right));
}
export {
  clsx,
  mergeProps
};
//# sourceMappingURL=mergeProps.es.js.map
